// client/src/routes/_auth/forgot-password.tsx — SCR-AUTH-005, first half · AUTH-004.

import { createFileRoute, redirect } from '@tanstack/react-router';

import { ForgotPasswordForm } from '@/features/auth/ForgotPasswordForm';
import { DEFAULT_LANDING } from '@/features/auth/redirect';
import { ensureSession } from '@/session';

export const Route = createFileRoute('/_auth/forgot-password')({
  beforeLoad: async () => {
    if (await ensureSession()) throw redirect({ href: DEFAULT_LANDING });
  },
  component: ForgotPasswordForm,
});
